import {pluralize} from "@pg-mono/string-utils";

import {IFlatInvestmentBooster} from "../../types/booster_generic/IFlatInvestmentBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {areOfferLeftPropertiesStatsValid} from "../../utils/offer_stats/are_offer_left_properties_stats_valid";
import {getLastFlatPropertyWithCountingText} from "../../utils/texts/last_property_text";

export const flatInvestmentBalconyBooster: IFlatInvestmentBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Balcony,

    isValid(params) {
        return areOfferLeftPropertiesStatsValid(params.offer.stats?.building_parameters_stats?.properties_with_balconies);
    },

    getSegments(params) {
        const stats = params.offer.stats?.building_parameters_stats?.properties_with_balconies;

        if (!stats || !stats.left) {
            return null;
        }

        const flatLeftTextPluralize = pluralize(["zostało", "zostały", "zostało"])(stats.left);

        return [
            "Złap okazję! W tej inwestycji",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${flatLeftTextPluralize} ${getLastFlatPropertyWithCountingText(stats.left)}`
            },
            "z balkonem."
        ];
    }
};
import {pluralize} from "@pg-mono/string-utils";

import {IFlatInvestmentBooster} from "../../types/booster_generic/IFlatInvestmentBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {areOfferLeftPropertiesStatsValid} from "../../utils/offer_stats/are_offer_left_properties_stats_valid";
import {getLastFlatPropertyWithCountingText} from "../../utils/texts/last_property_text";

export const flatInvestmentBalconyBooster: IFlatInvestmentBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Balcony,

    isValid(params) {
        return areOfferLeftPropertiesStatsValid(params.offer.stats?.building_parameters_stats?.properties_with_balconies);
    },

    getSegments(params) {
        const stats = params.offer.stats?.building_parameters_stats?.properties_with_balconies;

        if (!stats || !stats.left) {
            return null;
        }

        const flatLeftTextPluralize = pluralize(["zostało", "zostały", "zostało"])(stats.left);

        return [
            "Złap okazję! W tej inwestycji",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${flatLeftTextPluralize} ${getLastFlatPropertyWithCountingText(stats.left)}`
            },
            "z balkonem."
        ];
    }
};
